var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedTool && _vm.selectedTool.id === "singlePointofFailure"
    ? _c(
        "div",
        { staticClass: "spf" },
        [
          _c(
            "h5",
            { staticStyle: { "margin-bottom": "10px", "text-align": "left" } },
            [_c("u", [_vm._v(_vm._s(_vm.$t("SelectTwoBuildings")))])]
          ),
          _vm._v(" "),
          _c("tools-buttons", { on: { "set-selection": _vm.setSelection } }),
          _vm._v(" "),
          _c("div", { staticClass: "clear-all-container" }, [
            _vm.selectionType
              ? _c(
                  "h5",
                  {
                    staticStyle: { "margin-top": "10px", cursor: "pointer" },
                    on: { click: _vm.deleteAll }
                  },
                  [_c("u", [_vm._v(_vm._s(_vm.$t("ClearAll")))])]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._l(_vm.getBuildings, function(building) {
            return _vm.selectionType
              ? _c(
                  "div",
                  {
                    key: building.uuid,
                    staticClass: "floating-object-selected"
                  },
                  [
                    _c("div", { staticClass: "building-info" }, [
                      _c("img", {
                        staticStyle: { width: "15px", height: "15px" },
                        attrs: { src: require("@/assets/spf/building.png") }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "text-align": "left",
                            "padding-left": "5px",
                            color: "black"
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.objectIdentification(building)) +
                              "\n            "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-icon",
                      {
                        staticClass: "delete-icon",
                        attrs: { small: "" },
                        on: {
                          click: function($event) {
                            return _vm.deleteBuilding(building)
                          }
                        }
                      },
                      [_vm._v("\n            mdi-delete\n        ")]
                    )
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c("div", { staticClass: "spf-action-btns-container" }, [
            _c("p", { on: { click: _vm.cancelSpf } }, [
              _vm._v(_vm._s(_vm.$tc("Cancel")))
            ]),
            _vm._v(" "),
            _c("p", { on: { click: _vm.executeSpf } }, [
              _c("u", [_vm._v(_vm._s(_vm.$tc("Execute")))])
            ])
          ])
        ],
        2
      )
    : _vm.selectedTool
    ? _c("div", { staticClass: "failure-Analysis-action-btns-container" }, [
        _c("p", { on: { click: _vm.cancelFa } }, [
          _vm._v(_vm._s(_vm.$tc("Cancel")))
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37a08c02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37a08c02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/RightSidebar/spf/SinglePointOfFailure.vue
// module id = null
// module chunks = 